import React from "react";
import { STHead, STPrivacyPolicy } from "../../components";

const PrivacyPolicy = () => {
  return (
    <>
      <STHead
        title="Privacy Policy"
        description="Read the Sustanix Privacy Policy to understand how we protect and manage your data."
        keywords="Sustanix privacy policy, data protection, privacy"
        canonicalUrl="https://sustanix.com/privacy-policy/"
        ogTitle="Privacy Policy - Sustanix"
        ogDescription="Read the Sustanix Privacy Policy to understand how we protect and manage your data."
        ogKeywords="Sustanix privacy policy, data protection, privacy"
        ogUrl="https://sustanix.com/privacy-policy/"
        ogImage="https://sustanix.com/opengraph-image.webp"
        ogType="website"
      />
      <STPrivacyPolicy />
    </>
  );
};

export default PrivacyPolicy;
